// eslint-disable-next-line import/prefer-default-export
export const SET_CURRENT_TENANT = 'multi-tenancy/SET_CURRENT_TENANT';
